/** @jsx jsx */
import { css, jsx } from "@emotion/react"
import { useTheme } from "components/common/Context/ThemeContext"
import PropTypes from "prop-types"

const CMSCard = ({
  clickable = false,
  children,
  disabled,
  href,
  onClick,
  noPadding = false,
  dataTestId,
  backgroundColor,
  borderColor,
  height,
  className,
  borderWidth
}) => {
  const theme = useTheme()
  const useStyles = (theme) => {
    return {
      customCard: css`
        background-color: ${backgroundColor ||
        (disabled ? theme.disabledText : theme.cancelBtnBg)};
        box-shadow: ${`0px 1px 4px ${theme.boxShadowColor}`};
        border-radius: 4px;
        border: ${`${borderWidth || "0.5px"} solid ${
          borderColor || "transparent"
        } `};
        opacity: 1;
        position: relative;
        margin: 0px;
        display: flex;
        max-width: 100%;
        flex-direction: column;
        word-wrap: break-word;
        color: ${theme.primaryTextColor};
        cursor: ${clickable
          ? disabled
            ? "not-allowed"
            : "pointer"
          : "inherit"};
        padding: ${noPadding ? "0px" : "20px"};
        justify-content: center;
        height: ${height || "100%"};
      `,
      customClickableCard: css`
        &:hover,
        &:focus {
          background-color: ${backgroundColor ||
          (disabled ? theme.disabledText : theme.cardHoverBgColor)};
          box-shadow: ${`0px 1px 4px ${theme.cardHoverBoxShadow}`};
          color: inherit !important;
          font-weight: inherit;
          outline: none;
        }
        ,
        &:active {
          background-color: ${backgroundColor ||
          (disabled ? theme.disabledText : theme.cancelBtnBg)};
          box-shadow: ${`0px 1px 4px ${theme.cardHoverBoxShadow}`};
          border: ${`${borderWidth || "0.5px"} solid ${
            theme.cardActiveBorderColor
          } `};
        }
      `
    }
  }
  const classes = useStyles(theme)

  if (clickable && !disabled) {
    return (
      <a
        href={href || "/#"}
        onClick={(e) => {
          if (!href) {
            e.preventDefault()
          }
          if (onClick) {
            onClick()
          }
        }}
        target={"_blank"}
        data-testid={dataTestId}
        css={[classes.customClickableCard, classes.customCard]}
        rel="noopener noreferrer"
        className={className}
      >
        {children}
      </a>
    )
  }

  return (
    <div
      css={classes.customCard}
      data-testid={dataTestId}
      className={className}
    >
      {children}
    </div>
  )
}
export default CMSCard

CMSCard.propTypes = {
  clickable: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
  dataTestId: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  noPadding: PropTypes.bool,
  height: PropTypes.string,
  className: PropTypes.string,
  borderWidth: PropTypes.string
}
